import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { OverlayService } from 'src/app/services/overlay.service';
import { Store } from 'src/app/store';

@Component({
    selector: 'app-rate-info',
    templateUrl: './rate-info.component.html',
    styleUrls: ['./rate-info.component.css']
})
export class RateInfoComponent implements OnInit {
    @Input() rateData: any = undefined
    @Output() closeQueryRate = new EventEmitter();


    overlays$ = this.store.select<any>('overlays');
    booking$ = this.store.select<any>('booking');
    availabilitySearch$ = this.store.select<any>('availabilitySearch');
    profile$ = this.store.select<any>('profile');

    planSelected: any;
    infoPlan: any;

    ratePlans = [];

    constructor(
        private store: Store,
        private overlayService: OverlayService,
    ) { }

    ngOnInit(): void {
        console.log(this.rateData.rates.ratePlans)
        if (this.rateData.rates) {
            this.ratePlans = this.rateData.rates.ratePlans;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.planSelected = undefined;
        // if (changes.ratePlans.currentValue.length < 2) {
        //     this.selectRatePlan(changes.ratePlans.currentValue[0]);
        // }
    }

    close() {
        this.closeQueryRate.emit();
    }

    // info(ratePlan) {
    //     this.store.set('infoPlan', ratePlan)
    //     this.overlayService.toggle('ratePlanInfo', true)
    // }

}
